export default {
    eventAttendees: {}
}